import React, { Component } from 'react';
import "./review.css"

class About extends Component {
    state = {

    }
    componentDidMount(){
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <div>
            
        

<br/>


<div class="container">
        <h2  style={{fontSize:"32px",fontWeight:"800",margin:"0px",color:"#008071",textAlign:"center"}}>Our Customers <br/> Have to Say
        </h2>
        <div class="reviewSection">

  

        
<div class="reviewItem">
  <div class="top1">
    <div class="clientImage">
      <div style={{display:"flex"}}>
        <div>
          <p style={{height:"50px",width:"49px",fontSize:"24px",color:"white",fontWeight:"bold",background:"#454565",textAlign:"center",padding:"5px",borderRadius:"35px"}}>M</p>
        </div>
        <div style={{paddingRight:"10px"}}>
          <span>محمد الرشيد</span>
          <p className='review_para'>01 ديسمبر 2025</p>
        </div>
      </div>
      <div>
        <ul style={{color:"#f6bb06",fontSize:"24px",margin:"0px",lineHeight:"normal"}}>
          ★★★★★
        </ul>
      </div>
    </div>
  </div>
  <article>
    <p class="review">
      "أفضل متجر للدهانات في الرياض! الجودة ممتازة والأسعار مناسبة، وخدمة العملاء سريعة واحترافية."
    </p>
  </article>
</div>



<div class="reviewItem">
  <div class="top1">
    <div class="clientImage">
      <div style={{display:"flex"}}>
        <div>
          <p style={{height:"50px",width:"49px",fontSize:"24px",color:"white",fontWeight:"bold",background:"#454565",textAlign:"center",padding:"5px",borderRadius:"35px"}}>A</p>
        </div>
        <div style={{paddingRight:"10px"}}>
          <span>أحمد الحسين</span>
          <p className='review_para'>10 نوفمبر 2025</p>
        </div>
      </div>
      <div>
        <ul style={{color:"#f6bb06",fontSize:"24px",margin:"0px",lineHeight:"normal"}}>
          ★★★★★
        </ul>
      </div>
    </div>
  </div>
  <article>
    <p class="review">
      "تجربة شراء رائعة، الدهانات أصلية ومتنوعة، والتوصيل كان سريعًا جدًا. أنصح بهذا المتجر بشدة."
    </p>
  </article>
</div>


<div class="reviewItem">
  <div class="top1">
    <div class="clientImage">
      <div style={{display:"flex"}}>
        <div>
          <p style={{height:"50px",width:"49px",fontSize:"24px",color:"white",fontWeight:"bold",background:"#454565",textAlign:"center",padding:"5px",borderRadius:"35px"}}>S</p>
        </div>
        <div style={{paddingRight:"10px"}}>
          <span>سارة المطيري</span>
          <p className='review_para'>22 أكتوبر 2025</p>
        </div>
      </div>
      <div>
        <ul style={{color:"#f6bb06",fontSize:"24px",margin:"0px",lineHeight:"normal"}}>
          ★★★★★
        </ul>
      </div>
    </div>
  </div>
  <article>
    <p class="review">
      "خدمة ممتازة وطاقم محترف. الدهانات وصلت في حالة ممتازة مع تغليف آمن. أحببت التنوع والأسعار."
    </p>
  </article>
</div>

<div class="reviewItem">
  <div class="top1">
    <div class="clientImage">
      <div style={{display:"flex"}}>
        <div>
          <p style={{height:"50px",width:"49px",fontSize:"24px",color:"white",fontWeight:"bold",background:"#454565",textAlign:"center",padding:"5px",borderRadius:"35px"}}>R</p>
        </div>
        <div style={{paddingRight:"10px"}}>
          <span>رياض القحطاني</span>
          <p className='review_para'>30 أغسطس 2025</p>
        </div>
      </div>
      <div>
        <ul style={{color:"#f6bb06",fontSize:"24px",margin:"0px",lineHeight:"normal"}}>
          ★★★★★
        </ul>
      </div>
    </div>
  </div>
  <article>
    <p class="review">
      "خدمة ممتازة، الدهانات عالية الجودة ومناسبة لجميع الاستخدامات المنزلية والتجارية. أنصح الجميع بهذا المتجر."
    </p>
  </article>
</div>



<div class="reviewItem">
  <div class="top1">
    <div class="clientImage">
      <div style={{display:"flex"}}>
        <div>
          <p style={{height:"50px",width:"49px",fontSize:"24px",color:"white",fontWeight:"bold",background:"#454565",textAlign:"center",padding:"5px",borderRadius:"35px"}}>R</p>
        </div>
        <div style={{paddingRight:"10px"}}>
          <span>رياض القحطاني</span>
          <p className='review_para'>30 أغسطس 2025</p>
        </div>
      </div>
      <div>
        <ul style={{color:"#f6bb06",fontSize:"24px",margin:"0px",lineHeight:"normal"}}>
          ★★★★★
        </ul>
      </div>
    </div>
  </div>
  <article>
    <p class="review">
      "خدمة ممتازة، الدهانات عالية الجودة ومناسبة لجميع الاستخدامات المنزلية والتجارية. أنصح الجميع بهذا المتجر."
    </p>
  </article>
</div>






        </div>
    </div>
          </div>
        )
    }
}

export default About;